<template>
    <div style="text-align: center">
        <h2>บันทึกมิเตอร์ไฟฟ้า</h2>
        <div class="mt-4 row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ชื่อห้องพัก</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input v-model="rentalForm.rental_name"
                       disabled
                       type="text" class="form-control"/>
            </b-col>
        </div>
        <div class="mt-4 row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>วันที่คิดมิเตอร์ไฟ</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <date-picker
                    v-model="form.date_record"
                    type="date"
                    :format="changeFormat"
                    :lang="lang"
                    confirm
                    placeholder="วันที่บันทึกมิเตอร์">
                </date-picker>&nbsp;&nbsp;
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>จดครั้งก่อน</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input v-model="form.unit_before"
                       type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>หน่วย</label>
            </b-col>
        </div>

        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>จดครั้งหลัง</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input v-model.number="form.unit_after"
                       type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>หน่วย</label>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ใช้ไป(หน่วย)</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input class="form-control" disabled v-model="form.total_unit"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>หน่วย</label>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>รวม(หน่วย)</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input v-model="form.total_price"
                       type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitElectricityBill"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก
            </button>
            &nbsp&nbsp
            <button type="button"
                    @click="cancelElectricityBill"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
        <pre class="alert-success" style="display: none">{{ calculateUnitToUse }}</pre>
        <pre class="alert-success" style="display: none">{{ calculateTotalPrice }}</pre>
        <!--        <pre>{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    name: "electricity-bill-modal",
    components: {DatePicker},
    created() {
    },
    data() {
        return {
            currentDate: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            form: state => {
                return state.ElectricityBill.form;
            },
            rentalForm: state => {
                return state.RentalFee.rentalFeeForm;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        calculateUnitToUse() {
            this.form.total_unit = 0;
            let unit_after = this.form.unit_after ? this.form.unit_after : 0;
            let unit_before = this.form.unit_before ? this.form.unit_before : 0;
            if (this.form.unit_after >= this.form.unit_before) {
                this.form.total_unit = parseFloat(unit_after) - parseFloat(unit_before);
            }
            return this.form.total_unit;
        },
        calculateTotalPrice() {
            if (this.form.total_unit) {
                this.form.total_price = parseFloat(this.form.total_unit) * parseFloat(this.rentalForm.bill);
            } else {
                this.form.total_price = 0;
            }
        },

    },
    methods: {
        submitElectricityBill() {
            if (!this.form.unit_after) {
                alert('กรุณากรอกการจดครั้งหลัง')
            } else if (this.form.unit_after < this.form.unit_before) {
                alert('กรุณากรอกการจดครั้งหลังให้ถูกต้อง')
            } else if (!this.form.date_record) {
                alert('กรุณาเลือกวันที่');
            } else {
                let dataElectricityBill = {
                    id: this.form.id,
                    rental_id: this.rentalForm.id,
                    unit_before: this.form.unit_before,
                    unit_after: this.form.unit_after,
                    total_price: this.form.total_price,
                    total_unit: this.form.total_unit,
                    date_record: this.form.date_record ? moment(this.form.date_record).format("YYYY-MM-DD") : '',
                    recorder: this.user.id,
                }

                //console.log(dataElectricityBill);
                this.$emit("submit", dataElectricityBill)
            }
        },
        cancelElectricityBill() {
            this.$emit("submit", 0)
        },
    }
}
</script>

<style scoped>

</style>
